$(document).ready(function() {

// ----------------------------------------------------------------------------------
// Audioplayer
// ----------------------------------------------------------------------------------

    $(document).on('click','.audioplayer',function () {
        //var player = document.getElementById("audioplayer");

        var id= $(this).find('.player').eq(0).attr('id');

        console.log(id);

        var player=document.getElementById(id);


        pl = $(this)

        player.onended = function () {
            pl.removeClass('playing');
        };
        player[player.paused ? 'play' : 'pause']();
        $(this).toggleClass('playing');
    })

// ----------------------------------------------------------------------------------
// Videoplayer
// ----------------------------------------------------------------------------------
    $(document).on('click','.video-embed',function () {

        $(this).find('.play').fadeToggle(500);

        var video = $(this).parent().find('video')[0];

        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }

    })
});